<template>
    <div class="o-sms-modal-ready-header-valid sms-modal-ready-header-valid">
        <div class="sms-modal-ready-header-valid__wrapper">
            <h2 
                class="sms-modal-ready-header-valid__title" 
                v-html="$t('o-sms-modal-ready-header-valid_title')"
            />
            <svg-icon
                original
                name="icons/phone-path"
                class="sms-modal-ready-header-valid__icon"
            />
        </div>
        <span 
            class="sms-modal-ready-header-valid__subtitle"
            v-html="$t('o-sms-modal-ready-header-valid_subtitle', { value: item })"
        />
    </div>
</template>

<script>
export default {
    name: 'OSmsModalReadyHeaderValid',
    props: {
        item: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss">
@import "o-sms-modal-ready-header-valid";
</style>